import React, { PropsWithChildren, useContext, useState } from 'react';

export enum FeatureFlagsSet {
  learnEmbedRemoval = 'learn-embed-removal',
  schedulesShare = 'schedules-share',
  aiSyllabusSchedule = 'ai-syllabus-schedule',
  osmosisAiGa = 'osmosis-ai-ga',
  osmosisAiEmbeddedChat = 'ai-embedded-chat',
  osmosisAiCKS = 'osmosis-ai-cks',
  learnCks = 'learn-cks',
  fingerprintEnabled = 'fingerprint-enabled',
  b2cReferralsDisabled = 'b2c-referrals-disabled',
  /** Master gate for whether any learn-page A/B test framework runs at all. */
  learnABTest = 'learn-ab-test',
  /** Hides discounted-plan messaging from users in an active free trial. */
  trialDiscountMessagingDisabled = 'trial-discount-messaging-disabled',
}

export type FeatureFlagsContextProps = {
  featureFlags: string[];
  isActive: (featureFlag: string) => boolean;
};

const FeatureFlagsContext = React.createContext<FeatureFlagsContextProps>({
  featureFlags: [],
  isActive: () => false,
});

/**
 * Topics provider.
 */
export const FeatureFlagsProvider = (
  props: PropsWithChildren<{
    featureFlags?: string[];
  }>,
) => {
  const { children, featureFlags: featureFlagsProp = [] } = props;

  const [featureFlags] = useState(featureFlagsProp);

  const isActive = (featureFlag: string): boolean =>
    featureFlags.includes(featureFlag);

  return (
    <FeatureFlagsContext.Provider value={{ isActive, featureFlags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

/**
 * Hook to access the topics context.
 */
export const useFeatureFlagsContext = (): FeatureFlagsContextProps =>
  useContext(FeatureFlagsContext);
